import {Directory} from "../filesystem";
import {getPathFromRoot} from "./pathUtils";

export function getPrompt(dir: Directory): string {
    const path = getPathFromRoot(dir).join('/');
    return (path ?? "~") + " $";
}